module.exports = __webpack_public_path__ + "media/images/carte-credito-2df7f1c0.png";